<template>
    <div class="data-box">
        <div class="cont-pro-index-data">
            <GridList width="240">
                <div class="data-li">
                    <div class="icon-crowdfunding icon"></div>
                    <div class="data">
                        <strong>￥{{ tools.fmoney( Number(props.pro_info.backer_money) > 0 ? Number(props.pro_info.backer_money) : 0.00) }}</strong>
                        <span>众筹金额</span>
                    </div>
                </div>
                <div class="data-li">
                    <div class="icon-portion icon"></div>
                    <div class="data">
                        <strong>{{ props.pro_info.progress ? props.pro_info.progress : '0.00%' }}</strong>
                        <span>完成进度</span>
                    </div>
                </div>
                <div class="data-li">
                    <div class=" icon-person icon"></div>
                    <div class="data">
                        <strong>{{ props.pro_info.backer_count ? props.pro_info.backer_count: 0 }}</strong>
                        <span>支持人数</span>
                    </div>
                </div>
                <div class="data-li">
                    <div class=" icon-money icon"></div>
                    <div class="data">
                        <strong>￥{{ tools.fmoney(props.pro_info.backer_count > 0 ? props.pro_info.backer_money / props.pro_info.backer_count : (props.pro_info.backer_count || 0.00)) }}</strong>
                        <span>人均金额</span>
                    </div>
                </div>
                <div class="data-li">
                    <div class=" icon-collect icon"></div>
                    <div class="data">
                        <strong>{{ props.pro_info.favor_count ? props.pro_info.favor_count : 0 }}</strong>
                        <span>看好人数</span>
                    </div>
                </div>
                <div class="data-li">
                    <div class=" icon-comment icon"></div>
                    <div class="data">
                        <strong>{{ props.pro_info.comment_count ? props.pro_info.comment_count : 0 }}</strong>
                        <span>评论数</span>
                    </div>
                </div>
            </GridList>
        </div>
        <div v-if="props.pro_info.pro_class != '201' && ((props.pro_info.backer_money && Number(props.pro_info.backer_money) > 0 && state.all_money.length) || (props.pro_info.comment_count && Number(props.pro_info.comment_count) > 0 && state.comment.length))" class="chats-box">
            <div class="chart-item chart-left" v-if="props.pro_info.backer_money && Number(props.pro_info.backer_money) > 0 && state.all_money.length">
                <CompMoneny
                    :riqi="state.riqi"
                    :all_money="state.all_money"
                    :goal="props.pro_info.goal"
                    :backer_money="props.pro_info.backer_money"/>
            </div>
            <div class="chart-item" v-if="props.pro_info.comment_count && Number(props.pro_info.comment_count) > 0 && state.comment.length">
                <CompComment
                    :riqi="state.riqi"
                    :comment="state.comment"
                    :comment_count="props.pro_info.comment_count"/>
            </div>
        </div>
    </div>
</template>

<script setup>
import tools from '@/utils/tools.js'
import { defineProps, reactive, watch } from "vue";

import GridList from "@@/common/gridList.vue"; 
import CompMoneny from "@@/index/Money.vue";
import CompComment from "@@/index/Comment.vue";
import { getAjaxDataAnalysis } from "@/api/index"
const props = defineProps({
    pro_id: String,
    pro_info: Object,
    isWds: Boolean
})
const state = reactive({
    riqi: [], // 时间
    all_money: [],      // 累计金额 -筹款金额
    comment: [],        // 评论趋势
})
const getData = () => {
    if (props.pro_info.id) {
        getAjaxDataAnalysis({
            pro_id: props.pro_info.id
        }).then(res => {
            if (res.status == 0) {
                state.riqi = res.data.riqi
                state.all_money = res.data.all_money
                state.comment = res.data.comment
            }
        })
    }
}

watch(() => {[props.pro_info]}, () => {
    getData()
}, { deep: true, immediate: true })
</script>

<style lang="scss" scoped>
.data-box {
    .cont-pro-index-data {
        .data-li {
            display: flex;
            align-items: center;
            height: 82px;
            .icon {
                width: 42px;
                height: 42px;
                background: #F8F8F8;
                border-radius: 50%;
                text-align: center;
                line-height: 42px;
                font-size: 22px;
                color: #7F7F7F;
                margin-right: 10px;
            }
            .data {
                display: flex;
                flex-direction: column;
                justify-content: center;
                strong {
                    font-size: 18px;
                }
            }
        }
    }
    .chats-box {
        width: 100%;
        display: grid;
        grid-template-areas: 'a b' 'c d';
        border-top: 1px solid #E8E8E8;
        margin-top: 20px;
        .chart-item {
            padding: 20px 20px 0;
            position: relative;
        }
        .chart-left::after {
            display: block;
            content: '';
            width: 1px;
            height: calc(100% - 50px);
            background-color: #E8E8E8;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}
</style>
